import React from 'react'
import BlurOrangeDecorationSmall from '../decorations/BlurOrangeDecorationSmall'
import BlurBlueDecorationSmall from '../decorations/BlurBlueDecorationSmall'

const MainDecorationA = () => {
    return (
        <>
            <div className='position-absolute' style={{ top: '106.46px', left: '-79.18px', zIndex: '-1' }}>
                <BlurOrangeDecorationSmall />
            </div>
            <div className='position-absolute' style={{ top: '701.14px', left: '-90px', zIndex: '-1' }}>
                <BlurBlueDecorationSmall />
            </div>
            <div className='position-absolute d-none d-lg-block' style={{ top: '100px', right: '-5%', zIndex: '-1' }}>
                <BlurBlueDecorationSmall />
            </div>
            <div className='position-absolute d-none d-lg-block' style={{ top: '705px', right: '10%', zIndex: '-1' }}>
                <BlurOrangeDecorationSmall />
            </div>
        </>
    )
}

export default MainDecorationA